<script lang="ts">
export default {
  name: 'OwnershipTypeFilter',
};
</script>

<script setup lang="ts">
import GenericMultiFilter from '@/components/v2/GenericMultiFilter.vue';

const OWNERSHIP_TYPE_OPTIONS: { label: string; value: string }[] = [
  { label: 'Public', value: 'Public' },
  { label: 'Private', value: 'Private' },
];

defineProps<{
  modelValue: string[];
}>();

const emit = defineEmits<{
  'update:modelValue': [value: string[]];
}>();

function onUpdate(value: (string | number)[]) {
  emit('update:modelValue', value as string[]);
}
</script>

<template>
  <GenericMultiFilter
    :options="OWNERSHIP_TYPE_OPTIONS"
    :model-value="modelValue"
    title="Ownership Type"
    chip-title-field="label"
    data-test="ownership-type-filter"
    data-test-prefix="ownership-type-filter"
    @update:model-value="onUpdate" />
</template>
